const routes = [
    //甲醇
    {
        path: 'methanol',
        name: '甲醇',
        component: () => import('@/views/methanol/index'),
    },
    {
        path: 'methanol/twoPage/industry',
        name: '甲醇行业动态二级页',
        component: () => import('@/views/methanol/twoPage/industry')
    },
    {
        path: 'methanol/industry',
        name: '甲醇行业动态详情页',
        component: () => import('@/views/methanol/detail/industry')
    },
    {
        path: 'methanol/twoPage/price',
        name: '甲醇价格二级页',
        component: () => import('@/views/methanol/twoPage/price')
    },
    {
        path: 'methanol/price',
        name: '甲醇价格详情页',
        component: () => import('@/views/methanol/detail/priceIndex')
    },
    {
        path: 'methanol/twoPage/rate',
        name: '甲醇开工率二级页',
        component: () => import('@/views/methanol/twoPage/rate')
    },
    {
        path: 'methanol/rate',
        name: '甲醇开工率详情页',
        component: () => import('@/views/methanol/detail/rate')
    },
    {
        path: 'methanol/twoPage/report',
        name: '甲醇研究报告二级页',
        component: () => import('@/views/methanol/twoPage/report')
    },
    {
        path: 'methanol/twoPage/yield',
        name: '甲醇产量二级页',
        component: () => import('@/views/methanol/twoPage/yield')
    },
    {
        path: 'methanol/yield',
        name: '甲醇产量详情页',
        component: () => import('@/views/methanol/detail/yield')
    },
    {
        path: 'methanol/twoPage/stock',
        name: '甲醇库存二级页',
        component: () => import('@/views/methanol/twoPage/stock')
    },
    {
        path: 'methanol/stock',
        name: '甲醇库存详情页',
        component: () => import('@/views/methanol/detail/stock')
    },
    {
        path: 'methanol/twoPage/exit',
        name: '甲醇进出口量二级页',
        component: () => import('@/views/methanol/twoPage/exit')
    },
    {
        path: 'methanol/exit',
        name: '甲醇进出口量详情页',
        component: () => import('@/views/methanol/detail/exit')
    },
    {
        path: 'methanol/twoPage/productPrice',
        name: '甲醇下游产品价格二级页',
        component: () => import('@/views/methanol/twoPage/productPrice')
    },
    {
        path: 'methanol/productPrice',
        name: '甲醇下游产品价格详情页',
        component: () => import('@/views/methanol/detail/productPrice')
    },
    {
        path: 'methanol/twoPage/demand',
        name: '甲醇需求量二级页',
        component: () => import('@/views/methanol/twoPage/demand')
    },
    {
        path: 'methanol/demand',
        name: '甲醇需求量详情页',
        component: () => import('@/views/methanol/detail/demand')
    },
    {
        path: 'methanol/twoPage/standard',
        name: '甲醇行业标准二级页',
        component: () => import('@/views/methanol/twoPage/standard')
    },
    {
        path: 'methanol/map',
        name: '甲醇地图',
        component: () => import('@/views/methanol/detail/map.vue')
    },
]
export default routes
